<template>
	<div class="text-left">
		<template v-if="$route.params.withdraw == 'pay'">
			<h2>Hesap Numaralarımız</h2>
			<table class="table">
				<tbody>
				<tr>
					<td><strong>BITCOIN (BTC)</strong></td>
					<td>3BiHrEgvYiu3K6oYbR1kYQkVMj6R7xw3Cr</td>
				</tr>
				<tr>
					<td><strong>TETHER (USDT)</strong></td>
					<td>1DXkxrkBAPDdTYxicVXSNmLTyrRAmVZ5u5</td>
				</tr>
				<tr>
					<td><strong>ETHEREUM (ETH)</strong></td>
					<td>0xcf22c3dcb750a1c55ab54c144075eda5d0cff6dc</td>
				</tr>
				<tr>
					<td><strong>RIPPLE (XRP)</strong></td>
					<td>rKdDdrbU3MedsG7VtBAir4RjC35tzjDZnr / <strong class="text-danger">Destination Tag: 994941</strong></td>
				</tr>
				<tr>
					<td><strong>LITE COIN (LTC)</strong></td>
					<td>LKPVZ3nCQeGiXwi2mA1Si6ecGC5huaAWpX</td>
				</tr>
				</tbody>
			</table>
			<div>
				<h4 class="text-danger">
					<strong>
						Yatırım işlemlerinizi yaptıktan sonra lütfen gerekli bilgileri Canlı Destek üzerinden operatörlerimize bildiriniz.
					</strong>
				</h4>
			</div>
		</template>

		<template v-if="$route.params.withdraw == 'withdraw'">
			<withdraw />
		</template>

	</div>
</template>

<script>
    import withdraw from '@/components/payments/form/coinPaymentsWithdraw'
    export default {
        name: "coin_payments",
        components: {withdraw},
	    mounted(){

	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/coinpayments.vue